export default {
	// section titles
	taskDetail: 'Detail úkolu',
	leadDetail: 'Detail příležitosti',
	psInfo: 'Informace o PS',
	clientInfo: 'Údaje o klientovi',
	note: 'Poznámka',
	resolverSettings: 'Nastavení řešitele',
	documentAttachment: 'Přiložení ID dokumentu',
	fileAttachment: 'Přiložení příloh',

	// taskTypes titles
	sellerRequestTaskType: 'Požadavek na obchodníka',
	backOfficeTaskType: 'Backoffice',
	mobileScanningTaskType: 'Mobilní skenování',
	contactClientTaskType: 'Kontaktuj klienta',
	manualLead: 'Manuální příležitost',

	// fields, buttons, other
	policyNumber: 'Vyhledat dle PS',
	proposalNumber: 'Číslo návrhu GP',
	policyHolderFirstName: 'Jméno pojistníka',
	policyHolderSurname: 'Příjmení pojistníka',
	policyHolderBusinessName: 'Název pojistníka',
	policyStatus: 'Stav PS',
	claimNoCP: 'Číslo PU',
	backOfficeSegment: 'Řešená oblast',
	title: 'Titul',
	firstName: 'Jméno',
	surname: 'Příjmení',
	businessName: 'Název',
	birthDate: 'Datum narození',
	street: 'Ulice',
	streetNo: 'Číslo popisné/orientační',
	businessIn: 'IČO',
	municipality: 'Obec',
	zipCode: 'PSČ',
	phoneNumber: 'Telefon',
	email: 'E-mail',
	clientInfoSearch: 'Vyhledat klienta',
	taskType: 'Typ úkolu',
	taskSubType: 'Podtyp úkolu',
	leadType: 'Název příležitosti',
	leadSubType: 'Podtyp příležitosti',
	taskSubTypeSellerRequest: 'Důvod kontaktování klienta',
	fulfillDate: 'Termín splnění',
	warningDate: 'Termín upozornění',
	additionalContactReason: 'Doplnění údajů',
	superiorRadio: 'Přímo nadřízený uživatel',
	subordinateRadio: 'Přímo podřízený uživatel',
	usersRadio: 'Uživatel',
	agencyRadio: 'IDK oblast',
	marketPlaceRadio: 'Založit do tržiště',
	userName: 'Jméno uživatele',
	login: 'Login uživatele',
	sellerIn: 'Získatelské/Agenturní číslo',
	userFirstName: 'Jméno uživatele',
	userSurname: 'Příjmení uživatele',
	documentId: 'ID dokumentu',
	idkRegion: 'Region',
	idkAgency: 'Oblast',
	createTask: 'Vytvořit úkol',
	createLead: 'Vytvořit příležitost',
	personIn: 'Rodné číslo',
	taskIsBeingCreated: 'Vytváří se úkol',
	leadIsBeingCreated: 'Vytváří se příležitost',

	//modals
	clientSearch: 'Vyhledání klienta',
	policySearch: 'Výsledek vyhledání PS',
	userSearch: 'Výsledek vyhledání uživatele',

	// warnings / dialogs
	nonUniqueSolver: 'Upřesněte podmínky, aby zadaným informacím o řešiteli odpovídal právě jeden uživatel.',
	noPSNumber: 'Číslo PS je vyžadováno.',
};
